import "./App.css";
import Header from "./components/1.Header/Header";
import Hero from "./components/2.Hero/Hero";
import AboutUs from "./components/3.AboutUs/AboutUs";
import Plans from "./components/4.Plans/Plans";
import Footer from "./components/5.Footer/Footer";
import Gallery from "./components/Gallery/Gallery";
import { Helmet } from "react-helmet-async";

function App() {
  return (
    <>
      <Helmet>
        <title>Revision Automotriz</title>
        <meta
          name="description"
          content="Compra seguro, no compres a ciegas. Elige tu vehículo y nosotros lo revisamos por ti sin que salgas de casa."
        />
        <link rel="canonical" href="https://revisionautomotriz.com/" />
      </Helmet>
      <div className="App">
        <Header />
        <Hero />
        <AboutUs />
        <Gallery />
        <Plans />
        <Footer />
      </div>
    </>
  );
}

export default App;
